export const VISUAL_ACUITY_OPTIONS = [
  "20/20",
  "20/25",
  "20/30",
  "20/40",
  "20/50",
  "20/60",
  "20/70",
  "20/80",
  "20/100",
  "20/150",
  "20/200",
  "20/300",
  "20/400",
  "10/400",
  "5/400",
  "CD 3M",
  "CD 2M",
  "CD 1M",
  "CD 0,5M",
  "VULTOS",
  "PL",
  "NPL",
];
